import type { StreamEntry } from "../ChartSpec";
import { type LegendParts, legendShowsAnything } from "./plan-panel-chrome";
import { SeriesLabel } from "./series-label";

type LegendStream = Pick<StreamEntry, "streamId" | "color" | "name" | "unitCategory"> & {
    sensorClusterName?: string | null;
    sensorElementName?: string | null;
};

export function PanelLegend({ streams, parts }: { streams: readonly LegendStream[]; parts: LegendParts }) {
    if (streams.length === 0 || !legendShowsAnything(parts)) return null;

    return (
        // px, not spacing tokens: --spacing is 0.24rem, so token sizes land on half pixels.
        <div
            className={"flex min-w-0 flex-wrap items-center justify-start gap-x-[18px] gap-y-[6px] border-t pt-[12px]"}
        >
            {streams.map((s) => (
                <div key={String(s.streamId)} className={"flex min-w-0 items-center gap-[6px]"}>
                    <span
                        aria-hidden
                        className={"inline-block h-[3px] w-[10px] shrink-0 rounded-[2px]"}
                        style={{ backgroundColor: s.color }}
                    />
                    {/* Without a font size here the line box takes its height from the inherited 16px. */}
                    <div className={"truncate text-[11px] leading-[14px]"}>
                        <SeriesLabel
                            deviceName={parts.devices ? s.name : null}
                            sensorClusterName={parts.sensorClusters ? s.sensorClusterName : null}
                            sensorElementName={parts.sensorElements ? s.sensorElementName : null}
                            showUnitCategory={parts.categories}
                            unitCategory={s.unitCategory}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}
